// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"173":"Barcode","724":"TeaserFullscreen","797":"Game"}[chunkId] + "." + {"173":"6162a38ee1552ac15e4b","724":"7f94019ae0e4bf17baaf","797":"336365399fa3a5f2b544"}[chunkId] + ".js";
};